import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const faqApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const mutation = withDefaultMeta(builder.mutation);
    const query = withDefaultMeta(builder.query);

    return {
      // Get all faqs
      getAllFaqs: query({
        query: () => "/faq",
        transformResponse: (responseData) => {
          const loadedFaqs = responseData.map((faq) => {
            faq.id = faq._id;
            return faq;
          });
          return loadedFaqs;
        },
      }),

      // Get subscription by ID endpoint
      getFaqById: query({
        query: (id) => `/faq/${id}`,
        providesTags: (result, error, id) => [{ type: "Faq", id }],
      }),

      // Create a new survey endpoint
      // Invalidates the tag of the existing survey with the same ID when the new survey is created.
      createFaq: mutation({
        query: (initial) => ({
          url: "/faq",
          method: "POST",
          body: {
            ...initial,
          },
        }),
        invalidatesTags: (result, error, arg) => [{ type: "Faq", id: arg.id }],
      }),

      updateFaq: mutation({
        query: ({ id, ...initial }) => ({
          url: `/faq/${id}`,
          method: "PUT",
          body: initial,
        }),
        invalidatesTags: (result, error, arg) => [{ type: "Faq", id: arg.id }],
      }),

      deleteFaq: mutation({
        query: ({ id }) => ({
          url: `/faq/${id}`,
          method: "DELETE",
        }),
        invalidatesTags: (result, error, arg) => [{ type: "Faq", id: arg.id }],
      }),
    };
  },
});

// Destructure and export hooks
export const {
  useCreateFaqMutation,
  useGetAllFaqsQuery,
  useUpdateFaqMutation,
  useDeleteFaqMutation,
  useGetFaqByIdQuery,
} = faqApiSlice;
